import client from '../../client'
import { ReferralSubjectCodeResponse, ValidateCodeResponse } from './types'

export * from './types'

export const findOrCreateSubjectCode = async () => {
  const { data } = await client.get<ReferralSubjectCodeResponse>(
    '/user/referrals/subjectCode'
  )
  return data
}

export const validateCode = async (code: string) => {
  const { data } = await client.get<ValidateCodeResponse>(
    `/user/referrals/subjectCode/validate/${code}`
  )
  return data
}
